import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { IUiState } from './state'
import { AlsUser } from '@/models/als/AlsUser'
import { AlsProduit } from '@/models/als/AlsProduit'
import { AlsTiers } from '@/models/als/AlsTiers'

const mutations: MutationTree<IUiState> = {    
    [types.UI_SET_CONTENT_HEIGHT]: (state,height:number) => {
        state.contentHeight = height
    },
    [types.UI_SET_RIGHT_DRAWER_OPEN]: (state,open:boolean) => {
        state.rightDrawerOpen = open
    },
    [types.UI_SET_RIGHT_DRAWER_ENABLE]: (state,enable:boolean) => {
        state.rightDrawerEnable = enable
    },
    [types.UI_CLOSE_SNACKBAR]: (state) => {
        state.snackMessages = []
    },
    [types.UI_ADD_SNACK_MESSAGE]: (state,message:string) => {
        state.snackMessages.splice(0,0,message)
    },    
    [types.UI_SET_ALLERGENE_VISIBLITY]: (state,visibility:boolean) => {
        state.showAllergene = visibility
    },    
    [types.UI_SET_CART_VISIBLITY]: (state,visibility:boolean) => {
        state.showCart = visibility
    },    

    [types.UI_SET_PRINT_MODE]: (state,enable:boolean) => {
        state.printMode = enable
    },        

    //////////////////////////////////////////////////////////////////
    // SEJOUR
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_SEJOUR]: (state,search:string) => {
        state.searchSejour = search
    },    
    [types.UI_SET_SORT_SEJOUR_DESC]: (state,desc:boolean) => {
        state.sortSejourDesc = desc
    },
    [types.UI_SET_SORT_SEJOUR_BY]: (state,sort:string) => {
        state.sortSejourBy = sort
    },


    //////////////////////////////////////////////////////////////////
    // USER
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_USER]: (state,search:string) => {
        state.searchUser = search
    },    
    [types.UI_SET_SORT_USER_DESC]: (state,desc:boolean) => {
        state.sortUserDesc = desc
    },
    [types.UI_SET_SORT_USER_BY]: (state,sort:string) => {
        state.sortUserBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_COMMANDE]: (state,search:string) => {
        state.searchCommande = search
    },    
    [types.UI_SET_SORT_COMMANDE_DESC]: (state,desc:boolean) => {
        state.sortCommandeDesc = desc
    },
    [types.UI_SET_SORT_COMMANDE_BY]: (state,sort:string) => {
        state.sortCommandeBy = sort
    },

     //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_MAIL_TEMPLATE]: (state,search:string) => {
        state.searchMailTemplate = search
    },    
    [types.UI_SET_SORT_MAIL_TEMPLATE_DESC]: (state,desc:boolean) => {
        state.sortMailTemplateDesc = desc
    },
    [types.UI_SET_SORT_MAIL_TEMPLATE_BY]: (state,sort:string) => {
        state.sortMailTemplateBy = sort
    },

     //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_MAIL_SKIN]: (state,search:string) => {
        state.searchMailSkin = search
    },    
    [types.UI_SET_SORT_MAIL_SKIN_DESC]: (state,desc:boolean) => {
        state.sortMailSkinDesc = desc
    },
    [types.UI_SET_SORT_MAIL_SKIN_BY]: (state,sort:string) => {
        state.sortMailSkinBy = sort
    },

    

}

export default mutations